import React from "react";

import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";

function WomenIncarceration() {
  return (
    <div>
      <h2 className="text-h-black">Stories of Incarceration</h2>
      <div className="voice-sect">
        <div className="voice-sect-style">
          <p className="text-p-orange">Jail as a Hostel Stay</p>
          <p>
            Zahra's arrest came at the time when the MQM had to denounce its
            affiliation with Altaf Hussain, who made inflammatory statements,
            condemning Pakistan as a hotbed of terrorism and claiming Mohajirs
            would have been better off choosing to remain in India. Zahra was
            accused of being at the rally where his speech was broadcast.
          </p>
          <div className="my-5">
            <AudioPlayer
              // style={{ width: "300px" }}
              style={{ borderRadius: "1rem" }}
              className="bg-none"
              // autoPlay
              // layout="horizontal"
              src={require("../../assets/audio/ZAHRA.wav")}
              //   onPlay={(e) => console.log("onPlay")}
              showSkipControls={true}
              showJumpControls={false}
              // other props here
            />
          </div>
        </div>
        <div className="voice-sect-style">
          <p className="text-p-orange">Little Access to the Law</p>
          <p>
            Farzana described turning to religion out of sheer terror. At the
            same time, echoing the disciplinary rhetoric of jail, it was here
            that she was astonished to meet people for the first time who did
            not seem to know how to prepare themselves properly for prayer.
            Farzana betrays the way in which religion is appropriated to
            reproduce moral order among prisoners and in daily prison life.
          </p>
          <div className="my-5">
            <AudioPlayer
              // style={{ width: "300px" }}
              style={{ borderRadius: "1rem" }}
              className="bg-none"
              // autoPlay
              // layout="horizontal"
              src={require("../../assets/audio/FARZANA.wav")}
              //   onPlay={(e) => console.log("onPlay")}
              showSkipControls={true}
              showJumpControls={false}
              // other props here
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default WomenIncarceration;
